import { ServiceKey } from "@journeyteam/dependency-injection";
import {
	CustomersApi,
	UserApi,
	RolesApi,
	InvoicesApi,
	WorkInProgressApi,
	RepairOrdersApi,
	ServiceRequestTypesApi,
	PortalConfigApi,
	RequestedRepairOrdersApi,
	PageContentApi,
} from "../api/apis";
export class APIService {
	public static serviceKey = ServiceKey.create<APIService>("APIService", APIService);
	public readonly customer: CustomersApi = new CustomersApi();
	public readonly invoices: InvoicesApi = new InvoicesApi();
	public readonly workInProgress: WorkInProgressApi = new WorkInProgressApi();
	public readonly roles: RolesApi = new RolesApi();
	public readonly users: UserApi = new UserApi();
	public readonly repairOrders: RepairOrdersApi = new RepairOrdersApi();
	public readonly serviceRequestTypes = new ServiceRequestTypesApi();
	public readonly portalConfig = new PortalConfigApi();
	public readonly requestedRepairOrders = new RequestedRepairOrdersApi();
	public readonly pageContent = new PageContentApi();
}
